const searchBar = () => {
  // the input field
  const $input = $("#searchBar");
  // clear button
  const $clearBtn = $("button[data-search='clear']");
  // Search offcanvas close button
  const $closeSearchBar = $("#close-offcanvas");
  // prev button
  const $prevBtn = $("button[data-search='prev']");
  // next button
  const $nextBtn = $("button[data-search='next']");
  // the context where to search
  const $content = $("#content");
  // jQuery object to save <mark> elements
  let $results;
  // the class that will be appended to the current
  // focused element
  const currentClass = "current";
  // the current index of the focused element
  let currentIndex = 0;
  // const scrollableDiv = document.querySelector('#content');

  /**
   * Jumps to the element matching the currentIndex
   */
  function jumpTo() {
    if ($results.length) {
      const $current = $results.eq(currentIndex);
      $results.removeClass(currentClass);
      if ($current.length) {
        $current.addClass(currentClass);
        // Better handling for position scroll in a scrollable div
        $current.attr("id", `mark-${currentIndex}`);
        document.getElementById(`mark-${currentIndex}`).scrollIntoView({
          block: "center",
          behavior: "smooth",
          inline: "start",
        });
      }
    }
  }

  /**
   * Searches for the entered keyword in the
   * specified context on input
   */
  $input.on("input", function () {
    const searchVal = this.value;
    $content.unmark({
      done() {
        $content.mark(searchVal, {
          separateWordSearch: true,
          done() {
            $results = $content.find("mark");
            $results.map((result, index) =>
              $(this).attr("id", `mark-${index}`)
            );
            currentIndex = 0;
            jumpTo();
          },
        });
      },
    });
  });

  /**
   * Clears the search
   */
  $clearBtn.add($closeSearchBar).on("click", () => {
    $content.unmark();
    $input.val("").focus();
  });

  /**
   * Next and previous search jump to
   */
  $nextBtn.add($prevBtn).on("click", function () {
    if ($results.length) {
      currentIndex += $(this).is($prevBtn) ? -1 : 1;
      if (currentIndex < 0) {
        currentIndex = $results.length - 1;
      }
      if (currentIndex > $results.length - 1) {
        currentIndex = 0;
      }
      jumpTo();
    }
  });

  // Handle Enter Key press to scroll to next occurrence
  $(document).on("keyup", (event) => {
    if ($input.is(":focus") && event.key === "Enter") {
      currentIndex += 1;
      if (currentIndex > $results.length - 1) {
        currentIndex = 0;
      }
      jumpTo();
    }
  });
};

export default searchBar;
